import { initializeApp } from "firebase/app";
import {
  getMessaging,
  isSupported,
  getToken,
  onMessage,
} from "firebase/messaging";

/* =========================================================================
   ✅ Config
   لازم القيم دي تكون موجودة في .env داخل الفرونت
 ========================================================================= */

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  messagingSenderId: process.env.REACT_APP_FIREBASE_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

export const vapidKey = process.env.REACT_APP_FIREBASE_VAPID_KEY;

// ✅ Init App مرة واحدة
export const app = initializeApp(firebaseConfig);

/* =========================================================================
   ✅ Safe Messaging Getter
 ========================================================================= */

export async function getMessagingSafe() {
  try {
    const supported = await isSupported();
    if (!supported) {
      console.warn("⚠️ Firebase messaging is not supported in this browser.");
      return null;
    }
    return getMessaging(app);
  } catch (e) {
    console.error("❌ getMessagingSafe error:", e);
    return null;
  }
}

/* =========================================================================
   ✅ Service Worker Registration
 ========================================================================= */

export async function registerFcmServiceWorker() {
  if (!("serviceWorker" in navigator)) return null;

  try {
    const reg = await navigator.serviceWorker.register("/firebase-messaging-sw.js");

    // ✅ make sure it's ready
    await navigator.serviceWorker.ready;

    return reg;
  } catch (err) {
    console.error("❌ registerFcmServiceWorker error:", err);
    return null;
  }
}

/* =========================================================================
   ✅ Get Token
 ========================================================================= */

export async function getFcmToken() {
  const messaging = await getMessagingSafe();
  if (!messaging) return null;

  if (!vapidKey) {
    console.warn("⚠️ Missing REACT_APP_FIREBASE_VAPID_KEY");
    return null;
  }

  // ✅ request permission
  const permission = await Notification.requestPermission();
  if (permission !== "granted") return null;

  const swReg = await registerFcmServiceWorker();
  if (!swReg) return null;

  try {
    const token = await getToken(messaging, {
      vapidKey,
      serviceWorkerRegistration: swReg,
    });

    return token || null;
  } catch (err) {
    console.error("❌ getFcmToken error:", err);
    return null;
  }
}

/* =========================================================================
   ✅ Foreground Listener
 ========================================================================= */

export async function listenToForegroundMessages(callback) {
  const messaging = await getMessagingSafe();
  if (!messaging) return null;

  return onMessage(messaging, (payload) => {
    try {
      if (typeof callback === "function") callback(payload);
    } catch (e) {
      console.error("❌ Foreground callback error:", e);
    }
  });
}
